(function () {
  const STORAGE_KEY = "cookieConsentAccepted";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function init() {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY) === "true";
      const banner = document.getElementById("cookie-consent");
      const okBtn = document.getElementById("cookie-consent-ok");
      if (!banner || !okBtn) return;

      if (accepted) {
        banner.setAttribute("hidden", "hidden");
        return;
      }

      banner.removeAttribute("hidden");

      okBtn.addEventListener("click", function () {
        try {
          localStorage.setItem(STORAGE_KEY, "true");
        } catch (e) {
          // ignore
        }
        banner.setAttribute("hidden", "hidden");
      });
    } catch (e) {
      // If anything goes wrong, fail silently to not break the page
    }
  }

  // Initialize on DOM ready; also support Turbo if present
  ready(init);
  if (window.Turbo && window.Turbo.navigator) {
    document.addEventListener("turbo:load", init);
  }
})();
